import axiosInstance from './axiosInstance';
import axios from 'axios';
import { BASE_URL, ENDPOINTS } from './endpoints';

// دالة مساعدة لجلب هيدر المصادقة عند استخدام مكتبة axios الخام
const getAuthHeader = () => {
    const token = localStorage.getItem('Token') || localStorage.getItem('token') || localStorage.getItem('access_token');
    return {
        headers: {
            Authorization: token ? `Bearer ${token}` : '',
        },
    };
};

// 1️⃣ خدمات المصادقة والحساب (Authentication & Account Services)
export const authService = {
    login: async (email, password) => {
        const payload = new URLSearchParams();
        payload.append('username', email);
        payload.append('password', password);
        
        const response = await axios.post(`${BASE_URL}${ENDPOINTS.AUTH.LOGIN}`, payload, {
            withCredentials: true, 
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        });
        return response.data;
    },

    signup: async (userData) => {
        const response = await axiosInstance.post(ENDPOINTS.AUTH.SIGNUP, {
            company_name: userData.company_name,
            admin_user_name: userData.admin_user_name,
            admin_email: userData.email,
            admin_password: userData.password,
            phone_number: userData.phone_number
        });
        return response.data;
    },

    logout: async () => {
        const response = await axiosInstance.post(ENDPOINTS.AUTH.SIGNOUT, {});
        localStorage.removeItem('token');
        localStorage.removeItem('Token');
        localStorage.removeItem('access_token');
        return response.data;
    },

    deleteAccount: async () => {
        const response = await axiosInstance.delete(ENDPOINTS.AUTH.DELETE_ACCOUNT);
        return response.data;
    },

    forgotPassword: async (email) => {
        const response = await axiosInstance.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
        return response.data;
    },

    resetPasswordConfirm: async (token, newPassword) => {
        const response = await axiosInstance.post(ENDPOINTS.AUTH.RESET_PASSWORD, {
            token: token,
            new_password: newPassword
        });
        return response.data;
    },

    // authService.js — استبدل الدالة الحالية بهذي فقط
refreshToken: async () => {
    try {
        const response = await axios.post(
            `${BASE_URL}/auth/refresh`,   // 👈 شلنا الشرطة النهائية
            {}, 
            { withCredentials: true } 
        );
        
        const newAccessToken = response.data.access_token;   // 👈 المفتاح الصحيح
        
        if (newAccessToken) {
            localStorage.setItem('token', newAccessToken); 
            return newAccessToken;
        }
        return null;
    } catch (error) { 
        console.error("فشل تجديد التوكن:", error);
        return null;
    }
},

    verifyOtp: async ({ pre_auth_token, code }) => {
        const response = await axiosInstance.post(ENDPOINTS.AUTH.VERIFY_OTP, { pre_auth_token, code });
        return response.data;
    },

    executeFinalPurge: async (companyId) => {
        const response = await axiosInstance.delete(`/auth/admin/purge-company/${companyId}`); 
        return response.data;
    },

    restoreCompanyAccount: async (companyId) => {
        const response = await axiosInstance.post(`/auth/admin/restore-company/${companyId}`);
        return response.data;
    },

    updateSuperAdmin: async (formData) => {
        const response = await axiosInstance.post(ENDPOINTS.AUTH.UPDATE_SUPER_ADMIN, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },
};

// 2️⃣ خدمات السوبر أدمن (Super Admin Services)
export const superAdminService = {
    getPendingCompanies: async () => {
        try {
            const response = await axiosInstance.get(ENDPOINTS.AUTH.PENDING_COMPANIES);
            return response.data;
        } catch (error) {
            console.error("خطأ في جلب الشركات المعلقة:", error);
            throw error;
        }
    },
    approveCompany: async (companyId) => {
        try {
            const response = await axiosInstance.put(ENDPOINTS.AUTH.APPROVE_COMPANY(companyId), {});
            return response.data;
        } catch (error) {
            console.error(`خطأ في تفعيل الشركة ${companyId}:`, error);
            throw error;
        }
    }
};

// 3️⃣ إدارة بنوك الشركة (Company Banks Management)
export const companyBankService = {
    getAllBanks: async (config = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.COMPANY_BANKS.GET_ALL, config);
    return response.data;
},
    createBank: async (bankData) => {
        const response = await axiosInstance.post(ENDPOINTS.COMPANY_BANKS.CREATE, {
            ...bankData,
            company_id: 1 
        });
        return response.data;
    },
    updateBank: async (bankId, bankData) => {
        const response = await axiosInstance.put(ENDPOINTS.COMPANY_BANKS.UPDATE(bankId), bankData);
        return response.data;
    },
    deleteBank: async (bankId, targetId = null) => {
        const config = targetId ? { params: { target_id: targetId } } : {};
        const response = await axiosInstance.delete(ENDPOINTS.COMPANY_BANKS.DELETE(bankId), config);
        return response.data;
    },
    getArchivedBanks: async () => {
        const response = await axiosInstance.get(ENDPOINTS.COMPANY_BANKS.ARCHIVED_ITEMS);
        return response.data;
    },
   restoreBank: async (bankId, relinkDependencies = true) => {
  const response = await axiosInstance.post(
    ENDPOINTS.COMPANY_BANKS.RESTORE(bankId),
    null,
    { params: { relink_dependencies: relinkDependencies } }
  );
  return response.data;
},
};

// 4️⃣ إدارة الموردين (Vendors Management)
export const vendorService = {
    getAllVendors: async (config = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.VENDORS.GET_ALL, config); 
    return response.data;
},
    createVendor: async (vendorData) => {
        const formData = new FormData();
        formData.append("name", vendorData.name || "");
        formData.append("phone_number", vendorData.phone_number || "");
        formData.append("email", vendorData.email || "");
        formData.append("website", vendorData.website || "");
        formData.append("country", vendorData.location?.country || "");
        formData.append("city", vendorData.location?.city || "");
        formData.append("address", vendorData.location?.address || "");
        formData.append("building", vendorData.location?.building || "");
        formData.append("street", vendorData.location?.street || "");

        // 🆕 يدعم رفع أكثر من ملف: كل ملف من vendorData.license_files
        // (مصفوفة) بينضاف بنفس المفتاح "license_files" عشان FastAPI
        // يستقبلها كـ list[UploadFile] بالباك اند.
        const files = Array.isArray(vendorData.license_files) ? vendorData.license_files : [];
        files.forEach((file) => {
            if (file instanceof File) {
                formData.append("license_files", file);
            }
        });

        const response = await axiosInstance.post(ENDPOINTS.VENDORS.CREATE, formData, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    },
    updateVendor: async (vendorId, vendorData) => {
        const formData = new FormData();
        formData.append("name", vendorData.name || "");
        formData.append("phone_number", vendorData.phone_number || "");
        formData.append("email", vendorData.email || "");
        formData.append("website", vendorData.website || "");
        formData.append("country", vendorData.location?.country || "");
        formData.append("city", vendorData.location?.city || "");
        formData.append("address", vendorData.location?.address || "");
        // 💡 تم إضافة الحقول الناقصة هنا
        formData.append("building", vendorData.location?.building || "");
        formData.append("street", vendorData.location?.street || "");

        // 🆕 يدعم رفع أكثر من ملف: كل ملف من vendorData.license_files
        // (مصفوفة) بينضاف بنفس المفتاح "license_files" عشان FastAPI
        // يستقبلها كـ list[UploadFile] بالباك اند.
        const files = Array.isArray(vendorData.license_files) ? vendorData.license_files : [];
        files.forEach((file) => {
            if (file instanceof File) {
                formData.append("license_files", file);
            }
        });

        // 🆕 IDs الملفات القديمة المطلوب حذفها بالتحديد (لا تؤثر على باقي الملفات)
        const removedIds = Array.isArray(vendorData.removed_document_ids) ? vendorData.removed_document_ids : [];
        if (removedIds.length > 0) {
            formData.append("removed_document_ids", removedIds.join(","));
        }

        // إذا كان الباك إند لديك لا يقبل الملفات مع PUT، يمكنك إرسال POST مع محاكاة PUT
        // formData.append("_method", "PUT");
        // const response = await axiosInstance.post(ENDPOINTS.VENDORS.UPDATE(vendorId), formData...

        const response = await axiosInstance.put(ENDPOINTS.VENDORS.UPDATE(vendorId), formData, {
            headers: { "Content-Type": "multipart/form-data" }
        }); 
        return response.data;
    },
    deleteVendor: async (vendorId, config = {}) => {
        const response = await axiosInstance.delete(ENDPOINTS.VENDORS.DELETE(vendorId), config);
        return response.data;
    },
    restoreVendor: async (vendorId, relinkDependencies = true) => {
  const response = await axiosInstance.post(
    ENDPOINTS.VENDORS.RESTORE(vendorId),
    null,
    { params: { relink_dependencies: relinkDependencies } }
  );
  return response.data;
},

};
// 5️⃣ إدارة الحاويات (Containers Management)
export const containerService = {
    getAll: async () => {
        const response = await axiosInstance.get(ENDPOINTS.CONTAINERS.GET_ALL);
        return response.data;
    },
    getById: async (containerId) => {
        const response = await axiosInstance.get(ENDPOINTS.CONTAINERS.UPDATE(containerId)); 
        return response.data;
    },
    create: async (data) => {
        const response = await axiosInstance.post(ENDPOINTS.CONTAINERS.CREATE, data);
        return response.data;
    },
    update: async (id, data) => {
        const response = await axiosInstance.put(ENDPOINTS.CONTAINERS.UPDATE(id), data);
        return response.data;
    },
    delete: async (id, confirmDelete = false) => {
    const response = await axiosInstance.delete(ENDPOINTS.CONTAINERS.DELETE(id), {
        params: { confirm_delete: confirmDelete }
    });
    return response.data;
},
    restoreContainer: async (containerId, relinkDependencies = true) => {
  const response = await axiosInstance.post(ENDPOINTS.CONTAINERS.RESTORE(containerId), null, {
    params: { relink_dependencies: relinkDependencies }
  });
  return response.data;
},
    getSingleContainer: async (containerId) => {
        const response = await axiosInstance.get(ENDPOINTS.CONTAINERS.GET_SINGLE(containerId));
        return response.data;
    },
    linkVendor: async (containerId, vendorId) => {
        const response = await axiosInstance.post(ENDPOINTS.CONTAINER_VENDOR.LINK(containerId, vendorId), {});
        return response.data;
    },
    getContainerDocuments: async (containerId) => {
    try {
        const response = await axiosInstance.get(ENDPOINTS.CONTAINER_VENDOR.GET_DOCUMENTS(containerId));
        return response.data;
    } catch (error) {
        // إذا كان الخطأ 404 (لا توجد مستندات)، نرجع مصفوفة فارغة بكود سليم كي لا تتعطل الشاشة
        if (error.response && error.response.status === 404) {
            return []; 
        }
        throw error; // أي خطأ آخر (مثل 500 أو شبكة) يتم رميه بشكل طبيعي
    }
},
    unlinkVendor: async (containerId, vendorId) => {
        const response = await axiosInstance.delete(ENDPOINTS.CONTAINER_VENDOR.UNLINK(containerId, vendorId));
        return response.data;
    },
    getContainerVendorsAndInvoices: async (containerId, config = {}) => {
        const response = await axiosInstance.get(ENDPOINTS.INVOICE_CONNECT.GET_VENDORS(containerId), config);
        return response.data;
    },
    linkInvoiceToContainer: async (invoiceId, containerId, config = {}) => {        
        const response = await axiosInstance.put(ENDPOINTS.INVOICE_CONNECT.LINK_INVOICE(invoiceId, containerId), {}, config);
        return response.data;
    },
    unlinkInvoiceFromContainer: async (invoiceId, config = {}) => {
        const response = await axiosInstance.delete(ENDPOINTS.INVOICE_CONNECT.UNLINK_INVOICE(invoiceId), config);
        return response.data;
    }
};

// 6️⃣ إدارة الفواتير التجارية والمبدئية (Invoices & PI Management)

export const invoiceService = {
    saveInvoice: async (formData) => {
    const response = await axiosInstance.post('/invoices/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }); 
    return response.data;
}, 


    getInvoices: async (config = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.INVOICES.GET_ALL, config);
    return response.data;
}, 
    getInvoiceById: async (id) => {
        const response = await axiosInstance.get(ENDPOINTS.INVOICES.GET_BY_ID(id));
        return response.data;
    }, 
    updateInvoice: async (id, formData) => {
    const response = await axiosInstance.put(ENDPOINTS.INVOICES.UPDATE(id), formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
}, 
    // ✅ إضافة المعامل confirmDelete مع قيمة افتراضية false
deleteInvoice: async (id, confirmDelete = false) => {
    const response = await axiosInstance.delete(ENDPOINTS.INVOICES.DELETE(id), {
        params: {
            confirm_delete: confirmDelete
        }
    });
    return response.data;
},  
    // ✅ الدالة الصحيحة المتوافقة مع كود FastAPI
// ✅ دالة الاستعادة الصحيحة
// 🟢 الصيغة الصحيحة لدالة الاستعادة داخل invoiceService.js
restoreInvoice: async (id, restoreTransfers = true, relinkContainers = true) => {
  const response = await axiosInstance.post(`/invoices/${id}/restore`, null, {
    params: {
      restore_transfers: Boolean(restoreTransfers),
      relink_containers: Boolean(relinkContainers)
    }
  });
  return response.data;
},
    getLinkedPIInvoices: async (invoiceId, config = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.INVOICES.GET_PI_INVOICES(invoiceId), config);
    return response.data;
},   
    uploadPI: async (formData) => {
        const response = await axiosInstance.post(ENDPOINTS.PI_INVOICES.UPLOAD_PI, formData);
        return response.data;
    },    
    // ✅✅ هذا هو التعديل الفعلي المطلوب - كان لسا يستخدم GET_UNLINKED
    // الآن يستدعي المسار الجديد '/pi_invoice/' مباشرة (كل الـ PIs بغض النظر عن الربط)
    getAllPIs: async (config = {}) => {
    const response = await axiosInstance.get('/pi_invoice/', config);
    return response.data;
},
    // ✨ دالة اختيارية جديدة لو حبيتي تستخدميها لاحقاً بنافذة الربط بـ CiInvoice.jsx
    getUnlinkedPIs: async () => {
        const response = await axiosInstance.get(ENDPOINTS.PI_INVOICES.GET_UNLINKED);
        return response.data;
    },
    getPiById: async (piId) => {
        const response = await axiosInstance.get(ENDPOINTS.PI_INVOICES.GET_BY_ID(piId));
        return response.data;
    },    
    getPiByIdAlternative: async (piId) => {
        const response = await axiosInstance.get(ENDPOINTS.PI_INVOICE_BY_ID.GET_BY_ID(piId));
        return response.data;
    },    
    updatePI: async (id, formData) => {
        const response = await axiosInstance.put(ENDPOINTS.PI_INVOICES.UPDATE(id), formData);
        return response.data;
    },    
    // في ملف الخدمات (authService)
    deletePI: async (id, confirmDelete = true) => {
    const response = await axiosInstance.delete(ENDPOINTS.PI_INVOICES.DELETE(id), {
        params: { confirm_delete: confirmDelete }
    });
    return response.data;
},
getPIById: async (piId) => {
    const response = await axiosInstance.get(`/pi_id_invoice/${piId}`);
    return response.data;
  },
    restorePI: async (id, relinks = {}) => {
  const response = await axiosInstance.post(ENDPOINTS.PI_INVOICES.RESTORE(id), { relink: relinks });
  return response.data;
},
};


// 7️⃣ إدارة المعاملات البنكية والحوالات (Bank Transfers Management)
export const bankManagementService = {
    // 1️⃣ جلب جميع الحوالات والتحويلات البنكية
    createTransferRequest: async (formData) => {
        return await axiosInstance.post(ENDPOINTS.BANKS_MANAGEMENT.CREATE_TRANSFER, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // 2️⃣ جلب الحوالات المفلترة (GET /banks/)
    getFilteredTransfers: async (invoiceId, invoiceType) => {
        return await axiosInstance.get(ENDPOINTS.BANKS_MANAGEMENT.GET_TRANSFERS, {
            params: { invoice_id: invoiceId, invoice_type: invoiceType }
        });
    },

    // 3️⃣ أرشفة الملف المدمج (POST /banks/archive-combined-pdf)
    archiveCombinedPdf: async (formData) => {
        return await axiosInstance.post(ENDPOINTS.BANKS_MANAGEMENT.ARCHIVE_COMBINED_PDF, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
     // دالة حذف مستند نهائياً من الأرشيف

    // 4️⃣ تحديث بيانات الحوالة (PUT /banks/{transfer_id})
    updateTransferDetails: async (transferId, payload) => {
        return await axiosInstance.put(ENDPOINTS.BANKS_MANAGEMENT.UPDATE_TRANSFER(transferId), payload);
    },

    // 5️⃣ حذف الحوالة مؤقتاً (DELETE /banks/{transfer_id})
    deleteTransferPermanent: async (transferId) => {
        return await axiosInstance.delete(ENDPOINTS.BANKS_MANAGEMENT.DELETE_TRANSFER(transferId));
    },

    // 6️⃣ استعادة الحوالة من الأرشيف (POST /banks/{transfer_id}/restore)
    restoreBankTransfer: async (transferId) => {
        return await axiosInstance.post(ENDPOINTS.BANKS_MANAGEMENT.RESTORE_TRANSFER(transferId));
    },

    // 7️⃣ إلغاء الحوالة مالياً (PUT /request-cancel/{transfer_id}/cancel)
    cancelTransfer: async (transferId) => {
        return await axiosInstance.put(ENDPOINTS.BANKS_MANAGEMENT.CANCEL_TRANSFER(transferId));
    },

    // 🌟 بقية الدوال المساعدة الخاصة بجلب بيانات الفاتورة والبحث
    getFullPackageData: async (id, type) => {
        return await axiosInstance.get(`/invoices/${id}/package?type=${type}`);
    },
    getTransferDocuments: (transferId) => axiosInstance.get(`/banks/${transferId}/documents`),
};

// 8️⃣ إدارة ملفات السويفت البنكية (SWIFT Files Management)
export const swiftService = {
    uploadSwiftFile: async (transferId, formData) => {
        const response = await axiosInstance.post(ENDPOINTS.SWIFT_FILES.UPLOAD(transferId), formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },
    getSwiftFiles: async (transferId) => {
        const response = await axiosInstance.get(ENDPOINTS.SWIFT_FILES.GET_FILES(transferId));
        return response.data;
    },
    updateSwiftFile: async (swiftId, formData) => {
        const response = await axiosInstance.put(ENDPOINTS.SWIFT_FILES.UPDATE(swiftId), formData);
        return response.data;
    },
    deleteSwiftFile: async (swiftId) => {
        if (!swiftId || swiftId === 'undefined') {
            throw new Error("Swift ID is missing or invalid");
        }
        const response = await axiosInstance.delete(ENDPOINTS.SWIFT_FILES.DELETE(swiftId));
        return response.data;
    },
    restoreSwiftFile: async (swiftId) => {   // 🆕
        if (!swiftId || swiftId === 'undefined') {
            throw new Error("Swift ID is missing or invalid");
        }
        const response = await axiosInstance.put(ENDPOINTS.SWIFT_FILES.RESTORE(swiftId));
        return response.data;
    }
};

// 9️⃣ ملفات الحاويات (Container Files Services)
export const containerFileService = {
    getDocumentsOnly: async (containerId, config = {}) => {
        const response = await axiosInstance.get(ENDPOINTS.CONTAINER_FILES.GET_DOCUMENTS(containerId), config);
        return response.data; 
    },
    uploadDocuments: async (containerId, formData, config = {}) => {
        const response = await axiosInstance.post(ENDPOINTS.CONTAINER_FILES.UPLOAD_DOCUMENTS(containerId), formData, config);
        return response.data;
    },
    deleteContainerDocuments: async (containerId, config = {}) => {
        const response = await axiosInstance.delete(ENDPOINTS.CONTAINER_FILES.DELETE_DOCUMENTS(containerId), config);
        return response.data;
    }
};

// 🔟 سجل النشاطات (Activity Logs Services)
export const activityService = {
    createActivityLog: async (logData) => {
        const response = await axiosInstance.post(ENDPOINTS.ACTIVITY_LOGS.CREATE, logData);
        return response.data;
    },
    getActivityLogs: async (params) => {
        const response = await axiosInstance.get(ENDPOINTS.ACTIVITY_LOGS.GET_ALL, { params });
        return response.data;
    },
    deleteLog: async (logId) => {
        const response = await axiosInstance.delete(ENDPOINTS.ACTIVITY_LOGS.DELETE(logId));
        return response.data;
    },
    restoreLog: async (logId) => {
        const response = await axiosInstance.put(ENDPOINTS.ACTIVITY_LOGS.RESTORE(logId), {});
        return response.data;
    },
    getRestorePreview: async (entityType, entityId) => {
    const response = await axiosInstance.get(`/entities/${entityType}/${entityId}/restore-preview`);
    return response.data;
  }
};

// 1️⃣1️⃣ خدمات المدير والدعوات (Admin & Invitation Services)
export const adminAndInviteService = {
    // 🗄️ إدارة الأرشيف (ARCHIVE_MANAGEMENT)
    getCompanyArchive: async () => {
        const response = await axiosInstance.get(ENDPOINTS.ARCHIVE_MANAGEMENT.GET_COMPANY_ARCHIVE);
        return response.data;
    },

    // ✉️ الدعوات (INVITATION)
    inviteUser: async (emailData) => {
        const response = await axiosInstance.post(ENDPOINTS.INVITATION.INVITE_USER, emailData);
        return response.data;
    },
    getAllInvitations: async () => {
        const response = await axiosInstance.get(ENDPOINTS.INVITATION.GET_ALL);
        return response.data;
    },

    // 👑 إدارة المسؤولين (ADMIN_MANAGEMENT)
    // 👑 تم التحديث إلى axiosInstance لضمان استقرار المسار وإنهاء الـ 422 تماماً
    activateAccount: async (activationData) => {
        const response = await axiosInstance.post(
            ENDPOINTS.ADMIN_MANAGEMENT.ACTIVATE_ACCOUNT, 
            activationData
        );
        return response.data;
    },
    deleteArchiveDocument: async (docId, config) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/archive/company/${docId}`, 
            config
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting archive document:", error);
        throw error;
    }
},
};

// 1️⃣2️⃣ إدارة الأدوار والصلاحيات والشاشات (Roles, Permissions & Screens)
export const roleAndScreenService = {
    // 🔑 إدارة الأدوار (ROLE_MANAGEMENT)
    updateRolePermissionsFirst: async (permissionData) => {
        const response = await axiosInstance.post(ENDPOINTS.ROLE_MANAGEMENT.UPDATE_PERMISSIONS, permissionData);
        return response.data;
    },
    getRoleTemplates: async () => {
        const response = await axiosInstance.get(ENDPOINTS.ROLE_MANAGEMENT.GET_TEMPLATES);
        return response.data;
    },

    // 🔄 تحديث وإدارة الأعضاء والأدوار (UPDATE_ROLE_MANAGEMENT)
    updateRolePermissionsSecond: async (permissionData) => {
        const response = await axiosInstance.post(ENDPOINTS.UPDATE_ROLE_MANAGEMENT.UPDATE_PERMISSIONS, permissionData);
        return response.data;
    },
    getAllMembersWithRoles: async () => {
        const response = await axiosInstance.get(ENDPOINTS.UPDATE_ROLE_MANAGEMENT.GET_ALL_MEMBERS);
        return response.data;
    },
    deleteRoleMember: async (userId) => {
        const response = await axiosInstance.delete(ENDPOINTS.UPDATE_ROLE_MANAGEMENT.DELETE_MEMBER(userId));
        return response.data;
    },
    getUserRoleDetails: async (userId) => {
        const response = await axiosInstance.get(ENDPOINTS.UPDATE_ROLE_MANAGEMENT.GET_USER(userId));
        return response.data;
    },
    updateRoleMember: async (userId, memberData) => {
        const response = await axiosInstance.put(ENDPOINTS.UPDATE_ROLE_MANAGEMENT.UPDATE_MEMBER(userId), memberData);
        return response.data;
    },

    // 🖥️ إدارة الشاشات والعمليات (SCREEN_MANAGEMENT)
    getScreens: async () => {
        const response = await axiosInstance.get(ENDPOINTS.SCREEN_MANAGEMENT.GET_SCREENS);
        return response.data;
    },
    getActions: async () => {
        const response = await axiosInstance.get(ENDPOINTS.SCREEN_MANAGEMENT.GET_ACTIONS);
        return response.data;
    },
    getProfileData: async () => {
        const response = await axiosInstance.get(ENDPOINTS.PROFILE_UPDATE_MANAGEMENT.GET_DATA);
        return response.data;
    },

    /**
     * 📤 تحديث إعدادات وبيانات الملف الشخصي
     */
    updateProfileSettings: async (profileData) => {
        // في طلبات الـ PUT: المعامل الثاني هو البيانات مباشرة (Payload) والـ instance يتولى الهيدرز
        const response = await axiosInstance.put(
            ENDPOINTS.PROFILE_UPDATE_MANAGEMENT.UPDATE_SETTINGS,
            profileData
        );
        return response.data;
    },
   // ❌ قبل:
// const response = await axios.post(`/api/users/${userId}/custom-permissions`, payload, config);

// ✅ بعد: استخدم axiosInstance المعرّف في مشروعك
updateUserPermissions: async (userId, payload) => {
  // ملاحظة: إذا كان axiosInstance مضافاً له /api في البداية، اكتب المسار بدون /api
  const response = await axiosInstance.post(`users/users/${userId}/custom-permissions`, payload);
  return response.data;
},

};

// 1️⃣3️⃣ إدارة بيانات المستخدم (User Management)
export const userManagementService = {
    getMe: async () => {
        const response = await axiosInstance.get(ENDPOINTS.USER_MANAGEMENT.GET_ME);
        return response.data;
    },
    getCompanyMembers: async () => {
        const response = await axiosInstance.get(ENDPOINTS.USER_MANAGEMENT.GET_COMPANY_MEMBERS);
        return response.data;
    },
    updateProfile: async (profileData) => {
        const response = await axiosInstance.put(ENDPOINTS.USER_MANAGEMENT.UPDATE_PROFILE, profileData);
        return response.data;
    },
    accessTestScreen: async () => {
        const response = await axiosInstance.get(ENDPOINTS.USER_MANAGEMENT.ACCESS_TEST_SCREEN);
        return response.data;
    },
    getMyPermissions: async () => {
        const response = await axiosInstance.get(ENDPOINTS.USER_MANAGEMENT.GET_MY_PERMISSIONS);
        return response.data;
    }
};

// 1️⃣4️⃣ إدارة بيانات البيان الجمركي (Manifest / Statement Management)
export const manifestService = {
    createManifest: async (manifestNumber, manifestDate, imageFile, config = {}) => {
    const fd = new FormData();
    fd.append('manifest_number', manifestNumber);
    if (manifestDate) fd.append('manifest_date', manifestDate);
    if (imageFile) fd.append('image_file', imageFile);

    const response = await axiosInstance.post(ENDPOINTS.ID_STATEMENT_MANAGEMENT.CREATE, fd, config);
    return response.data;
},
    getAllManifests: async (config = {}) => {
    const response = await axiosInstance.get(ENDPOINTS.ID_STATEMENT_MANAGEMENT.GET_ALL, config);
    return response.data;
},
    // في ملف authService.js
// داخل ملف authService.js
// داخل ملف authService.js

// في ملف authService.js
deleteManifest: async (manifestId, targetId = null) => {
    // 1. استخدام target_id (وليس target_manifest_id)
    const config = targetId ? { params: { target_id: Number(targetId) } } : {};

    // 2. إرجاع المسار الأصلي إذا كان السيرفر مجمعاً تحت /id-statement
    const response = await axiosInstance.delete(`/id-statement/manifests/${manifestId}`, config);
    return response.data;
},
    updateManifest: async (manifestId, manifestNumber, manifestDate, imageFile, config = {}) => {
    const fd = new FormData();
    fd.append('manifest_number', manifestNumber);
    if (manifestDate) fd.append('manifest_date', manifestDate);
    if (imageFile) fd.append('image_file', imageFile);

    const response = await axiosInstance.put(ENDPOINTS.ID_STATEMENT_MANAGEMENT.UPDATE(manifestId), fd, config);
    return response.data;
},
    // في ملف authService.js

restoreManifest: async (manifestId, relinkDependencies = true) => {
    const response = await axiosInstance.post(
        ENDPOINTS.ID_STATEMENT_MANAGEMENT.RESTORE(manifestId), // 👈 استخدام الاسم الصحيح الموجود في قائمة ENDPOINTS
        { relink_dependencies: relinkDependencies }             // 👈 إرسال الـ Body بالشكل الصحيح
    );
    return response.data;
},
    searchManifestNumber: async (manifestNumber) => {
        const response = await axiosInstance.get(ENDPOINTS.ID_STATEMENT_MANAGEMENT.SEARCH_NUMBER(manifestNumber));
        return response.data;
    },
    getManifestDetails: async (manifestId) => {
        const response = await axiosInstance.get(ENDPOINTS.ID_STATEMENT_MANAGEMENT.GET_DETAILS(manifestId));
        return response.data;
    },
    findManifest: async (manifestNumber) => {
        const response = await axiosInstance.get(ENDPOINTS.NUMBER_STATEMENT_MANAGEMENT.SEARCH(manifestNumber));
        return response.data;
    }
};

// 1️⃣5️⃣ معالجة الذكاء الاصطناعي (AI Processing Services)
export const aiProcessingService = {
    saveAiData: async (payload) => {
        const response = await axiosInstance.post(ENDPOINTS.AI_SERVICE_MANAGEMENT.SAVE_DATA, payload);
        return response.data;
    },

    analyzeBundle: async (filesArray, bundleType, onStatusUpdate) => {  // ✅ أضفنا الباراميتر
    if (!filesArray || filesArray.length === 0) return null;

    const fd = new FormData();

    if (filesArray.length === 1) {
        const file = filesArray[0];
        if (bundleType === "COO") {
            fd.append('coo_file', file);
        } else if (bundleType === "PACKING_LIST") {
            fd.append('packing_list_file', file);
        } else {
            fd.append('invoice_file', file);
        }
    } else {
        if (bundleType === "PI") {
            if (filesArray[0]) fd.append('invoice_file', filesArray[0]);
            if (filesArray[1]) fd.append('packing_list_file', filesArray[1]);
        } else if (bundleType === "CI") {
            if (filesArray[0]) fd.append('invoice_file', filesArray[0]);
            if (filesArray[1]) fd.append('coo_file', filesArray[1]);
            if (filesArray[2]) fd.append('packing_list_file', filesArray[2]);
        }
    }

    const submitResponse = await axiosInstance.post(
        ENDPOINTS.AI_SERVICE_MANAGEMENT.ANALYZE_BUNDLE,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    const { database_id } = submitResponse.data;
    if (!database_id) {
        throw new Error("لم يتم استلام database_id من السيرفر");
    }

    // ✅ مرّرنا الـ callback هون
    const data = await aiProcessingService.pollAnalysisStatus(database_id, onStatusUpdate);

    const finalResult = {
        Invoice_Info: data,
        Items: data?.items || [],
        COO_Info: {
            coo_number: data?.coo_number || null,
            coo_date: data?.coo_date || null,
            invoice_no_in_coo: data?.invoice_no_in_coo || null
        }
    };

    if (data?.invoice_no_in_coo && data?.invoice_number) {
        if (data.invoice_no_in_coo !== data.invoice_number) {
            finalResult.COO_Mismatch = {
                coo_invoice_number: data.invoice_no_in_coo,
                ci_invoice_number: data.invoice_number,
            };
        }
    }

    return finalResult;
},

pollAnalysisStatus: (databaseId, onStatusUpdate) => {  // ✅ أضفنا الباراميتر
    return new Promise((resolve, reject) => {
        const interval = setInterval(async () => {
            try {
                const statusRes = await axiosInstance.get(
                    `${ENDPOINTS.AI_SERVICE_MANAGEMENT.ANALYZE_BUNDLE}status/${databaseId}`
                );
                const { status, data, error } = statusRes.data;

                if (onStatusUpdate) onStatusUpdate(status);  // ✅ استدعاء الـ callback بكل مرة

                if (status === "COMPLETED") {
                    clearInterval(interval);
                    resolve(data);
                } else if (status === "FAILED") {
                    clearInterval(interval);
                    reject(new Error(error || "فشلت عملية التحليل"));
                }
            } catch (e) {
                console.warn("Polling attempt failed, retrying...", e);
            }
        }, 4000);
    });
},
// submitBundle: بس بترفع الملفات وترجع الـ job info فوراً، من غير انتظار
submitBundle: async (filesArray, bundleType) => {
    if (!filesArray || filesArray.length === 0) return null;

    const fd = new FormData();
    if (filesArray.length === 1) {
        const file = filesArray[0];
        if (bundleType === "COO") fd.append('coo_file', file);
        else if (bundleType === "PACKING_LIST") fd.append('packing_list_file', file);
        else fd.append('invoice_file', file);
    } else {
        if (bundleType === "PI") {
            if (filesArray[0]) fd.append('invoice_file', filesArray[0]);
            if (filesArray[1]) fd.append('packing_list_file', filesArray[1]);
        } else if (bundleType === "CI") {
            if (filesArray[0]) fd.append('invoice_file', filesArray[0]);
            if (filesArray[1]) fd.append('coo_file', filesArray[1]);
            if (filesArray[2]) fd.append('packing_list_file', filesArray[2]);
        }
    }

    const submitResponse = await axiosInstance.post(
        ENDPOINTS.AI_SERVICE_MANAGEMENT.ANALYZE_BUNDLE,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    const { database_id } = submitResponse.data;
    if (!database_id) throw new Error("لم يتم استلام database_id من السيرفر");

    return { database_id }; // ⬅️ يرجع فوراً، بدون أي polling هنا
},

// checkStatusOnce: نداء واحد بس (مش loop) — الـ loop هيبقى في الـ provider
checkStatusOnce: async (databaseId) => {
    const res = await axiosInstance.get(
        `${ENDPOINTS.AI_SERVICE_MANAGEMENT.ANALYZE_BUNDLE}status/${databaseId}`
    );
    return res.data; // { status, data, error }
},

// دالة مساعدة لتحويل نتيجة الـ status الخام لنفس شكل finalResult اللي كنت بتعتمد عليه
buildFinalResult: (data) => {
    const finalResult = {
        Invoice_Info: data,
        Items: data?.items || [],
        COO_Info: {
            coo_number: data?.coo_number || null,
            coo_date: data?.coo_date || null,
            invoice_no_in_coo: data?.invoice_no_in_coo || null
        }
    };
    if (data?.invoice_no_in_coo && data?.invoice_number && data.invoice_no_in_coo !== data.invoice_number) {
        finalResult.COO_Mismatch = {
            coo_invoice_number: data.invoice_no_in_coo,
            ci_invoice_number: data.invoice_number,
        };
    }
    return finalResult;
},
    combineInvoicePdfs: async (invoiceId) => {
        const response = await axiosInstance.post(ENDPOINTS.AI_EXTRA_SERVICES.COMBINE_PDFS(invoiceId), {});
        return response.data;
    },
    analyzeDocument: async (formData) => {
        const response = await axiosInstance.post(ENDPOINTS.AI_EXTRA_SERVICES.ANALYZE_DOCUMENT, formData);
        return response.data;
    },
    
    triggerSilentUpdate: async () => {
        const response = await axiosInstance.put(ENDPOINTS.AI_EXTRA_SERVICES.SILENT_TRIGGER, {});
        return response.data;
    },
    fullSearch: async (searchParams) => {
        const response = await axiosInstance.get(ENDPOINTS.AI_EXTRA_SERVICES.FULL_SEARCH, { params: searchParams });
        return response.data;
    },
    getVendorInvoicesSummary: async (vendorId) => {
        const response = await axiosInstance.get(ENDPOINTS.AI_EXTRA_SERVICES.GET_VENDOR_SUMMARY(vendorId));
        return response.data;
    },
    uploadDocumentsToAi: async (formData) => {
        const response = await axiosInstance.post(ENDPOINTS.AI_EXTRA_SERVICES.UPLOAD_DOCUMENTS, formData);
        return response.data;
    },
    getVendorsSummary: async () => {
        const response = await axiosInstance.get('/ai-services-list/summary_vendors/summary');
        return response.data;
    },
    processDocument: async (file, docType) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('doc_type', docType);

        const authHeader = getAuthHeader();
        const response = await axios.post(ENDPOINTS.AI.PROCESS_DOCUMENT, formData, {
            headers: {
                ...authHeader.headers,
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },


    
};
export const transferRequestService = {
    
    // 1️⃣ جلب قائمة الحوالات المفلترة برقم الفاتورة والنوع (تأخذ params)
    getFilteredTransfers: async (invoiceId, invoiceType) => {
        const response = await axiosInstance.get(ENDPOINTS.BANKS_MANAGEMENT.GET_TRANSFERS, {
            params: {
                invoice_id: invoiceId,
                invoice_type: invoiceType
            }
        });
        return response;
    },

    // 2️⃣ جلب بيانات الحزمة الكاملة للفاتورة (مع إرسال نوع الفاتورة كـ query param)
    getFullPackageData: async (invoiceId, invoiceType) => {
        const response = await axiosInstance.get(ENDPOINTS.AI_EXTRA_SERVICES.GET_FULL_PACKAGE(invoiceId), {
            params: { invoice_type: invoiceType }
        });
        return response;
    },

    // 3️⃣ البحث الشامل عن فاتورة برقمها

    // 4️⃣ إضافة حوالة مالية جديدة (FormData)
    addTransfer: async (formData) => {
        const response = await axiosInstance.post(ENDPOINTS.BANKS_MANAGEMENT.GET_TRANSFERS, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response;
    },

    // 5️⃣ رفع ملف السويفت البنكي للحوالة
    uploadSwiftFile: async (transferId, formData) => {
        const response = await axiosInstance.post(ENDPOINTS.SWIFT_FILES.UPLOAD(transferId), formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response;
    },

    // 6️⃣ إلغاء الحوالة مالياً (PUT)
    cancelTransfer: async (transferId) => {
        const response = await axiosInstance.put(ENDPOINTS.REQUEST_CANCEL.CANCEL(transferId), {});
        return response;
    },

    // 7️⃣ تحديث بيانات حوالة معينة (JSON)
    updateTransferDetails: async (transferId, formData) => {
    // 1️⃣ تنظيف المعرف (ID) لضمان عدم تمرير أي نصوص أو رموز مشوهة مثل ":1"
    const cleanId = String(transferId).replace(':', '').trim();

    // 2️⃣ إرسال الطلب مع تعديل الـ Content-Type ليتوافق مع استقبال الملفات
    const response = await axiosInstance.put(
        ENDPOINTS.BANKS_MANAGEMENT.UPDATE_TRANSFER(cleanId), 
        formData, // تمرير كائن الـ FormData الذي يحتوي على الملف والسعر والتاريخ
        {
            headers: { 
                // 🌟 خطوة مصيرية: تغيير الهيدر لتدعم رفع الملفات والبيانات معاً
                'Content-Type': 'multipart/form-data' 
            }
        }
    );
    return response;
},

    // 8️⃣ حذف الحوالة نهائياً من قاعدة البيانات
    deleteTransferPermanent: async (transferId) => {
        const response = await axiosInstance.delete(ENDPOINTS.BANKS_MANAGEMENT.DELETE_TRANSFER(transferId));
        return response;
    },

    // 9️⃣ حذف ملف السويفت فقط
    deleteSwiftFileOnly: async (swiftId) => {
        const response = await axiosInstance.delete(ENDPOINTS.SWIFT_FILES.DELETE(swiftId));
        return response;
    },

    // 🔟 أرشفة الـ PDF المدمج النهائي وإرساله لخادم الأرشيف الخاص بمجلد combine
    archiveCombinedPdf: async (formData) => {
        const response = await axiosInstance.post(ENDPOINTS.BANKS_MANAGEMENT.ARCHIVE_COMBINED_PDF, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response;
    },
    createTransferRequest: async (formData) => {
        return await axiosInstance.post('/banks/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    searchInvoiceByNo: async (invoiceNo) => {
    // 1. جلب التوكن من localStorage أو localStorage كبديل
    const token = localStorage.getItem('token') || localStorage.getItem('token');
    
    // 2. التحقق من وجود التوكن قبل إرسال الطلب
    if (!token) {
        console.error("لم يتم العثور على توكن المصادقة!");
        throw new Error("Unauthorized: No token found");
    }

    const response = await axios.get(
        `${BASE_URL}/ai-services-list/full-search/search?invoice_no=${encodeURIComponent(invoiceNo.trim())}`,
        { 
            headers: { 
                'Authorization': `Bearer ${token}` 
            } 
        }
    );

    return response.data;
},};

export default authService;